export class ProgressNotesModel {
patientcode = '' ;
progdate = '2024-01-01' ;
proglocation = '' ;
prognotes = '' ;
userid = '' ;
username = '' ;
progtime = '2024-01-01' ;

}
